<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				优惠券使用记录
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div>
		</div>
		<div class="searchbox" >
			<el-form :inline="true" ref="ruleForm" :model="params">
				<el-row>
					<el-col :span="5">
						<el-input size="mini" style="width:250px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keywords"
						@keyup.enter.native="searchValue" clearable></el-input>
						<el-button size="mini" @click="searchValue" icon="el-icon-search" type="warning">搜索</el-button>
					</el-col>
					<el-col :span="3">
						<el-form-item label="使用状态">
							<el-select style="width: 100px;" size="mini" v-model="params.use_status" placeholder="请选择" @change="search()">
								<el-option label="不可用" :value="Number('0')"></el-option>
								<el-option label="未使用" :value="Number('1')"></el-option>
								<el-option label="已使用" :value="Number('2')"></el-option>
								<el-option label="已过期" :value="Number('3')"></el-option>
								<el-option label="全部" :value="Number('-1')"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="领劵时间" prop="type_id">
							<el-col :span="10">
								<el-date-picker @change="search()" size="mini" type="date" value-format="timestamp" placeholder="选择日期" v-model="params.receive_start_time"
								style="width: 150px;"></el-date-picker>
							</el-col>
							<el-col class="line" :span="4" style="text-align: center;">至</el-col>
							<el-col :span="10">
								<el-date-picker @change="search()" size="mini" placeholder="选择时间" value-format="timestamp" v-model="params.receive_end_time"
								style="width: 150px;"></el-date-picker>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="使用时间" prop="type_id">
							<el-col :span="10">
								<el-date-picker @change="search()" size="mini" type="date" value-format="timestamp" placeholder="选择日期" v-model="params.use_start_time"
								style="width: 150px;"></el-date-picker>
							</el-col>
							<el-col class="line" :span="4" style="text-align: center;">至</el-col>
							<el-col :span="10">
								<el-date-picker @change="search()" size="mini" placeholder="选择时间" value-format="timestamp" v-model="params.use_end_time"
								style="width: 150px;"></el-date-picker>
							</el-col>
						</el-form-item>
					</el-col>
					
				</el-row>
			</el-form>
			</div>

			<div class="table">
				<el-table  default-expand-all :data="data.data" style="width: 100%">
					<el-table-column align="center" label-class-name="lablename" label="编号" prop="_no">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="用户名" prop="member_name">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="手机号" prop="member_mobile">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="使用门店" prop="use_shop">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="使用状态" prop="use_status">
						<template slot-scope="scope">
							<span v-if="scope.row.use_status==0">不可用</span>
							<span v-if="scope.row.use_status==1">未使用</span>
							<span v-if="scope.row.use_status==2">已使用</span>
							<span v-if="scope.row.use_status==3">已过期</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="领券日期" prop="receive_time">
						<template slot-scope="scope">
							<span>{{$public.FTime(scope.row.receive_time,'YYYY-MM-DD')}}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="使用日期" prop="receive_end_time">
						<template slot-scope="scope">
							<span>{{$public.FTime(scope.row.use_time,'YYYY-MM-DD')}}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="优惠券" prop="coupon_name">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="优惠券规则">
						<template slot-scope="scope">
							<span>满{{scope.row.money_top}}减{{scope.row.money_reduce}}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="应付款" prop="due_amount">
					</el-table-column>
					<el-table-column align="center" label-class-name="lablename" label="实付款" prop="actual_amount">
					</el-table-column>
				</el-table>
			</div>
	
		<div class="footer" v-if="data.count>params.pageSize">
			<div></div>
			<div class="paging">
				<el-pagination :hide-on-single-page="data.count<params.pageSize" @current-change="handleCurrentChange"
				:current-page="params.pageIndex" layout="total, prev, pager, next, jumper" :total="data.count">
				</el-pagination>
			</div>
		</div>


	</div>
</template>

<script>
	import {
		getUseCoupon,
		deletCoupon,
		setCoupon,
		offselfCoupon,
		onselfCoupon
	} from '../../../api/productApi.js'
	export default {

		data() {
			return {

				detailDailog: false,
				titleBtn: "展开筛选",
				screenShow: true,
				select: 1,
				selectfun: false,
				currentPage: 1,

				params: {
					coupon_id: '',
					keyword: '',
					shop_id: '',
					use_status: -1,
					receive_start_time: '',
					receive_end_time: '',
					use_start_time: '',
					use_end_time: '',
					pageIndex: 1,
					pageSize: 10,
				},

				data: {},

			}
		},
		created() {
			if (this.$route.query.id) {
				this.params.coupon_id = this.$route.query.id;
			}
			this.getListData(this.params)
			console.log(Date.parse(new Date()))

		},
		methods: {
			//展开/收起筛查条件
			toggleShow() {
				this.screenShow = !this.screenShow
				if (this.screenShow) {
					this.titleBtn = "收起筛选"
				} else {
					this.titleBtn = "展开筛选"
				}

			},
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path:'/fictitious/fictitious',
						query:{type:2}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//筛选按钮
			search() {
				let params = {
					coupon_id: this.params.coupon_id,
					use_status: this.params.use_status,
					shop_id: this.params.shop_id,
					receive_start_time: '',
					receive_end_time: '',
					use_start_time: '',
					use_end_time: '',

					pageIndex: this.params.pageIndex,
					pageSize: this.params.pageSize,
				}
				if (this.params.receive_start_time) {
					params.receive_start_time = (this.params.receive_start_time / 1000).toString()
				} else {
					params.start_time = ''
				}

				if (this.params.receive_end_time) {
					params.receive_end_time = (this.params.receive_end_time / 1000).toString()
				} else {
					params.receive_end_time = ''
				}
				if (this.params.use_start_time) {
					params.use_start_time = (this.params.use_start_time / 1000).toString()
				} else {
					params.use_start_time = ''
				}

				if (this.params.use_end_time) {
					params.use_end_time = (this.params.use_end_time / 1000).toString()
				} else {
					params.use_end_time = ''
				}

				this.getListData(params)
			},

			//table操作编辑  传所有的内容了
			edit(row) {
				this.editParams = row;
				this.editParams.receive_end_time = row.receive_end_time * 1000;
				this.editParams.receive_start_time = row.receive_start_time * 1000;
				this.editParams.use_start_time = row.use_start_time * 1000;
				this.editParams.use_end_time = row.use_end_time * 1000;
				this.dialogEditCoupon = true
				// this.$router.push({name:'editactivity',query:{id:id,pageIndex:this.params.pageIndex}})
			},
			//列表删除
			handleDelete(id) {
				let self = this
				this.$confirm('你确定要删除此条信息?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deletCoupon({
						query: {
							id
						}
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							self.getListData(this.params)
						} else {
							this.$message.error(res.info);
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleCurrentChange(val) {
				this.params.pageIndex = val;
				this.getListData(this.params)
			},
			//获取供应商列表
			getListData(params) {
				let self = this
				getUseCoupon(params).then(res => {
					if (res.code == 0) {
						self.data = res.data;
					} else {
						self.$message.error(res.info);
					}
				})
			},
			// 新建供应商
			add() {
				this.dialogEditCoupon = true;
				console.log(Date.parse(new Date()))
				this.editParams = {
					_id: '',
					coupon_name: '',
					money_top: 0,
					money_reduce: 0,
					receive_start_time: Date.parse(new Date()),
					receive_end_time: '',
					use_start_time: Date.parse(new Date()),
					use_end_time: '',
					remark: '',
					status: 1,
					use_scene: 2
				}
			},
			searchValue() {
				this.params.pageIndex = 1
				this.getListData(this.params)
			},
			submitForm(formName) {

				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.editParams.receive_start_time) {
							this.editParams.receive_start_time = (this.editParams.receive_start_time / 1000).toString()
						} else {
							this.$message('时间不能为空');
						}
						if (this.editParams.receive_end_time) {
							this.editParams.receive_end_time = (this.editParams.receive_end_time / 1000).toString()
						} else {
							this.$message('时间不能为空');
						}
						if (this.editParams.use_start_time) {
							this.editParams.use_start_time = (this.editParams.use_start_time / 1000).toString()
						} else {
							this.$message('时间不能为空');
						}
						if (this.editParams.use_end_time) {
							this.editParams.use_end_time = (this.editParams.use_end_time / 1000).toString()
						} else {
							this.$message('时间不能为空');
						}
						this.loadding = true;
						// switch()
						// this.editParams.receive_start_time = this.editParams.receive_start_time/1000
						// if(this.editParams.receive_start_time)
						console.log(typeof this.editParams.receive_start_time)
						setCoupon(this.editParams).then(res => {
							if (res.code == 0) {
								this.loadding = false;
								this.dialogEditCoupon = false;
								this.getListData(this.params)
							}
							console.log(res.code)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			offshelf(id) {
				offselfCoupon(
				{
						id
					}
				).then(res => {
					if (res.code == 0) {
						this.getListData(this.params)
					}
				})
			},
			onshelf(id) {
				onselfCoupon(
					{
						id
					}
			).then(res => {
					if (res.code == 0) {
						this.getListData(this.params)
					}
				})
			}
		},
		

	}
</script>

<style lang="scss" scoped="scoped">
	.searchbox {
		background-color: #fff;
		padding: 20px;
	}
	.table{
		margin-top: 10px;
	}
</style>
